import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import truncateChars from 'rebook/apps/utils/text/truncateChars';
import {
  CATALOG_AUTHOR_CITATIONS_SET_DATA,
  CATALOG_AUTHOR_CITATIONS_RESET_DATA,
} from 'rebook/apps/catalog/constants';
import { Author } from 'rebook/apps/catalog/models';


export function fetchInitialData(match, location = {}) {
  return async(dispatch, getState) => {
    const { authorSlug } = match.params;
    const currentState = getState().authorCitationList;

    let newState = {
      authorSlug,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    if (currentState.citations) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.author) {
      await dispatch(fetchAuthor(match));
    }
    if (!newState.citations) {
      await dispatch(fetchAuthorCitationList());
    }
  };
}

export function fetchAuthor(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { authorSlug } = match.params;
    const url = `/api/authors/s-${authorSlug}/`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(
        ({ data }) => {
          dispatch(setData({ author: data }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to load citation list author due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load citation list author detail due to server error');
          }
        }
      );
  };
}

const sortCitations = (citations) => {
  if (!citations.length) {
    return citations;
  }
  let result = [];

  for (let i = 0; i < citations.length; i++) {
    const isUserCitation = get(citations[i], 'my_citation', false);
    if (isUserCitation) {
      result.unshift(citations[i]);
    }
    else {
      result.push(citations[i]);
    }
  }

  return result;
};

export function fetchAuthorCitationList(page=1) {
  return async(dispatch, getState) => {
    const { authorCitationList, ssr } = getState();
    const { author } = authorCitationList;
    if (!author) {
      return;
    }
    // optimistically update the UI
    dispatch(setData({
      citations: null,
      pageNumber: page,
    }));
    const limit = 10;
    let queryParams = {
      author: author.id,
      html: 1,
      limit,
      offset: (page - 1) * limit,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/citations/?${qs}`;

    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(
        ({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / limit);
          dispatch(setData({
            citations: sortCitations(data.objects),
            pageNumber: page,
            lastPageNumber,
          }));
        }
      )
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('failed to load citation list due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load citation list detail due to server error');
        }
      );
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { authorCitationList, booksPerSubscriptionCounter } = getState();
    const { citations } = authorCitationList;
    const author = new Author(authorCitationList.author);
    const desktopUrl = `https://${BASE_HOST}${author.getCitationListUrl()}`;
    const authorUrl = `https://${BASE_HOST}${author.absolute_url}`;
    const title = `Лучшие цитаты из книг ${author.cover_name} — MyBook`;
    const description = truncateChars(
      `В электронной библиотеке MyBook можно прочитать более ${booksPerSubscriptionCounter.total} электронных книг ` +
      ` отзывов и рецензий, рейтинг книги по версии читателей электронной библиотеке MyBook.ru`,
      300
    );

    dispatch(SeoActions.setData({
      canonicalUrl: citations.length ? desktopUrl : authorUrl,
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { citations } = payload;
    dispatch({
      type: CATALOG_AUTHOR_CITATIONS_SET_DATA,
      payload,
    });
    if (citations) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: CATALOG_AUTHOR_CITATIONS_RESET_DATA,
    });
  };
}
